import { ReactComponent as LogoSvg } from "../../../logo-color-svg.svg";

export default function ColorLogo(props: { className?: string }) {
  return <LogoSvg className={props.className} />;
}
